export default function checkIsDesktop(width) {
  if (width > 600) {
    return true;
  } else {
    return false;
  }
}
